import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen, IsXsScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const BillingHelp = () => {
  const isMdScreen = IsMdScreen();
  const paddingValue = IsXsScreen() ? 1 : 3;

  return (
    <>
      <Stack padding={paddingValue} direction={"row"}>
        <ShContainer maxWidth='xl' margin='auto'>
          <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
            Billing and Subscriptions
          </ResourceTypography>
          <ResourceTypography variant="body1" paragraph>
            Manage your subscription plan, billing information, and payment history in one place.
            Choose the plan that best fits your hiring needs and scale as your organization grows.
          </ResourceTypography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Subscription Plans
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Select from our range of subscription plans designed for different organization sizes
            and hiring needs. Compare features and choose the plan that works best for you.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Billing Management
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            View and manage your billing information, including payment methods, invoices,
            and billing history. Update payment details and manage subscription renewals.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Usage Tracking
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Monitor your usage of platform features and resources. Track job postings,
            candidate communications, and other usage metrics against your plan limits.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Plan Upgrades
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Upgrade your plan to access additional features and higher usage limits.
            Our flexible plans allow you to scale your subscription as your hiring needs grow.
          </Typography>

          <Box paddingTop={2} paddingBottom={3}>
            <ShButton
              component={RouterLink}
              to="/employer/settings/account/subscriptions"
              color="primary"
              variant="contained"
            >
              Manage Subscription
            </ShButton>
          </Box>
        </ShContainer>
        {!isMdScreen && <CommonQuestionSidebar />}
      </Stack>
    </>
  );
};

export default BillingHelp; 